import type { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		fill="none"
		viewBox="0 0 16 16"
		{...props}
	>
		<path
			stroke="var(--svg-color, currentColor)"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M4.5 7.5h7M11 1.5V4M5 1.5V4M3.523 2.5h8.952a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3.523a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2"
		/>
	</svg>
);
export { SvgComponent as CalendarIcon };
